/**
 * InForce Lights — storefront GA4 ecommerce helpers + cart interceptors
 * Companion to snippets/datalayer-ecommerce.liquid
 * Never sends emails/phones.
 */
(function () {
  'use strict';

  // Prevent double-install if asset is included more than once
  if (window.__INFORCE_DL_JS__) return;
  window.__INFORCE_DL_JS__ = true;

  window.dataLayer = window.dataLayer || [];
  window.inforceDL = window.inforceDL || {};

  var CURRENCY =
    (window.__INFORCE_TRACKING__ && window.__INFORCE_TRACKING__.currency) ||
    (window.__INFORCE_CART__ && window.__INFORCE_CART__.currency) ||
    window.currencyMain ||
    'USD';

  var recentKeys = Object.create(null);
  var DEBOUNCE_MS = 800;

  function guardKey(key) {
    var now = Date.now();
    if (recentKeys[key] && now - recentKeys[key] < DEBOUNCE_MS) return false;
    recentKeys[key] = now;
    return true;
  }

  function centsToMajor(n) {
    if (n == null || n === '') return 0;
    var num = Number(n);
    if (isNaN(num)) return 0;
    // Shopify AJAX cart returns prices in cents (integer). If value looks like dollars already, keep it.
    if (Math.abs(num) >= 1000 || Number.isInteger(num)) {
      // Prefer cents→dollars for typical Shopify payloads (price 1999 = $19.99)
      // Heuristic: if __INFORCE_CART__ prices are floats and this is int, treat as cents.
      return Math.round(num) / 100;
    }
    return num;
  }

  function forceCentsToMajor(n) {
    if (n == null || n === '') return 0;
    return Math.round(Number(n)) / 100;
  }

  function pushEcommerce(eventName, ecommercePayload) {
    if (!eventName) return;
    var key =
      eventName +
      ':' +
      JSON.stringify(
        (ecommercePayload && ecommercePayload.items
          ? ecommercePayload.items.map(function (i) {
              return [i.item_id, i.quantity, i.price];
            })
          : ecommercePayload && ecommercePayload.transaction_id) || ecommercePayload || {}
      );
    if (!guardKey(key)) return;

    window.dataLayer.push({ ecommerce: null });
    var payload = { event: eventName };
    if (ecommercePayload) payload.ecommerce = ecommercePayload;
    window.dataLayer.push(payload);
  }

  window.inforceDL.pushEcommerce = pushEcommerce;

  function mapLineItem(item, index) {
    if (!item) return null;
    var variantId = item.variant_id || item.id;
    var sku = item.sku || variantId;
    var priceRaw = item.final_price != null ? item.final_price : item.price;
    var qty = item.quantity != null ? item.quantity : 1;
    return {
      item_id: String(sku),
      item_name: item.product_title || item.title || item.name || '',
      item_brand: item.vendor || '',
      item_category: item.product_type || '',
      item_variant: item.variant_title || item.variantTitle || '',
      price: forceCentsToMajor(priceRaw),
      quantity: qty,
      index: index != null ? index + 1 : undefined,
      shopify_variant_id: variantId,
      shopify_product_id: item.product_id,
      key: item.key
    };
  }

  function mapCartItems(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.map(mapLineItem).filter(Boolean);
  }

  function cartValue(cart) {
    if (!cart) return 0;
    if (cart.total_price != null) return forceCentsToMajor(cart.total_price);
    if (cart.value != null) return Number(cart.value) || 0;
    return mapCartItems(cart).reduce(function (sum, i) {
      return sum + (i.price || 0) * (i.quantity || 0);
    }, 0);
  }

  function syncCartSnapshot(cart) {
    if (!cart) return;
    window.__INFORCE_CART__ = {
      currency: cart.currency || CURRENCY,
      item_count: cart.item_count != null ? cart.item_count : (cart.items || []).length,
      value: cartValue(cart),
      items: mapCartItems(cart)
    };
  }

  // Use native fetch so internal cart reads never re-enter the interceptor.
  function getCart() {
    var fetchFn = nativeFetch || window.fetch;
    return fetchFn('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      return r.json();
    });
  }

  function itemsValue(items) {
    return (items || []).reduce(function (sum, i) {
      return sum + (Number(i.price) || 0) * (Number(i.quantity) || 0);
    }, 0);
  }

  function fireAddToCart(items, currency) {
    var list = Array.isArray(items) ? items : [items];
    list = list.filter(Boolean);
    if (!list.length) return;
    pushEcommerce('add_to_cart', {
      currency: currency || CURRENCY,
      value: itemsValue(list),
      items: list
    });
  }

  function fireRemoveFromCart(items, currency) {
    var list = Array.isArray(items) ? items : [items];
    list = list.filter(Boolean);
    if (!list.length) return;
    pushEcommerce('remove_from_cart', {
      currency: currency || CURRENCY,
      value: itemsValue(list),
      items: list
    });
  }

  function fireViewCart(cart) {
    syncCartSnapshot(cart);
    pushEcommerce('view_cart', {
      currency: (cart && cart.currency) || CURRENCY,
      value: cartValue(cart),
      items: mapCartItems(cart)
    });
  }

  function fireBeginCheckout(cart) {
    // Always prefer /cart.js (cent prices). Passing window.__INFORCE_CART__
    // (already major-unit prices, no total_price) into mapCartItems would /100 again.
    if (!cart || cart.total_price == null) {
      getCart()
        .then(function (fresh) {
          if (!fresh) return;
          syncCartSnapshot(fresh);
          pushEcommerce('begin_checkout', {
            currency: fresh.currency || CURRENCY,
            value: cartValue(fresh),
            items: mapCartItems(fresh)
          });
        })
        .catch(function () {});
      return;
    }
    syncCartSnapshot(cart);
    pushEcommerce('begin_checkout', {
      currency: cart.currency || CURRENCY,
      value: cartValue(cart),
      items: mapCartItems(cart)
    });
  }

  window.inforceDL.fireAddToCart = fireAddToCart;
  window.inforceDL.fireRemoveFromCart = fireRemoveFromCart;
  window.inforceDL.fireBeginCheckout = fireBeginCheckout;
  window.inforceDL.syncCartSnapshot = syncCartSnapshot;
  window.inforceDL.getCart = getCart;

  // --- Diff helpers for change/update ---
  function indexByKey(items) {
    var map = Object.create(null);
    (items || []).forEach(function (it) {
      var k = it.key || String(it.variant_id || it.id);
      map[k] = it;
    });
    return map;
  }

  function diffCarts(before, after) {
    var added = [];
    var removed = [];
    var b = indexByKey(before && before.items);
    var a = indexByKey(after && after.items);
    var keys = {};
    Object.keys(b).forEach(function (k) {
      keys[k] = true;
    });
    Object.keys(a).forEach(function (k) {
      keys[k] = true;
    });
    Object.keys(keys).forEach(function (k) {
      var bi = b[k];
      var ai = a[k];
      var bq = bi ? bi.quantity || 0 : 0;
      var aq = ai ? ai.quantity || 0 : 0;
      if (aq > bq) {
        var addItem = mapLineItem(ai || bi, 0);
        if (addItem) {
          addItem.quantity = aq - bq;
          added.push(addItem);
        }
      } else if (bq > aq) {
        var remSrc = bi || ai;
        var remItem = mapLineItem(remSrc, 0);
        if (remItem) {
          remItem.quantity = bq - aq;
          removed.push(remItem);
        }
      }
    });
    return { added: added, removed: removed };
  }

  // --- fetch interceptor (OBSERVE ONLY — never rewrite args or delay cart/checkout) ---
  // BUG (fixed 2026-09-21): previous wrapper did
  //   beforePromise.then(function (beforeCart) { return nativeFetch.apply(this, arguments) })
  // so `arguments` was [beforeCart], not (input, init). Every fetch — including
  // product-form ATC (`fetch(routes.cart_add_url)`) and cart.js change/update —
  // became fetch(null) or fetch(cartObject) and silently failed.
  var nativeFetch = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var isCartMut =
        /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(url) &&
        (method === 'POST' || method === 'PUT' || method === 'PATCH');

      // Snapshot in parallel — do NOT await before the real request.
      var beforePromise = isCartMut
        ? getCart().catch(function () {
            return null;
          })
        : null;

      // Critical: call native fetch with the ORIGINAL input/init (closure), never
      // Promise callback `arguments`.
      var responsePromise = nativeFetch(input, init);

      if (isCartMut) {
        responsePromise
          .then(function (response) {
            var clone;
            try {
              clone = response.clone();
            } catch (e) {
              return;
            }
            Promise.all([
              beforePromise,
              clone.json().catch(function () {
                return null;
              })
            ]).then(function (pair) {
              var beforeCart = pair[0];
              var data = pair[1];
              if (data) handleCartMutation(url, beforeCart, data);
              else {
                getCart()
                  .then(function (after) {
                    handleCartMutation(url, beforeCart, after);
                  })
                  .catch(function () {});
              }
            });
          })
          .catch(function () {});
      }

      return responsePromise;
    };
  }

  // --- XHR interceptor (observe only; attach load listener synchronously) ---
  if (window.XMLHttpRequest) {
    var XO = XMLHttpRequest.prototype.open;
    var XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__inforceUrl = url;
      this.__inforceMethod = method;
      return XO.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = String(xhr.__inforceUrl || '');
      var method = String(xhr.__inforceMethod || 'GET').toUpperCase();
      var isCartMut =
        /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(url) &&
        (method === 'POST' || method === 'PUT' || method === 'PATCH');

      if (isCartMut) {
        var beforeCart = null;
        var beforeReady = getCart()
          .then(function (c) {
            beforeCart = c;
          })
          .catch(function () {});
        // Attach BEFORE send so a fast response cannot race past the listener.
        xhr.addEventListener('load', function () {
          beforeReady.then(function () {
            try {
              var data = null;
              try {
                data = JSON.parse(xhr.responseText);
              } catch (e) {}
              if (data) handleCartMutation(url, beforeCart, data);
              else {
                getCart()
                  .then(function (after) {
                    handleCartMutation(url, beforeCart, after);
                  })
                  .catch(function () {});
              }
            } catch (e) {}
          });
        });
      }
      return XS.apply(this, arguments);
    };
  }

  function handleCartMutation(url, beforeCart, data) {
    var isAdd = /\/cart\/add/i.test(url);
    var isClear = /\/cart\/clear/i.test(url);
    var isChange = /\/cart\/(change|update)/i.test(url);

    if (isAdd) {
      // /cart/add.js may return a single line item or { items: [...] }
      var addedItems = [];
      if (data && data.items && Array.isArray(data.items)) {
        addedItems = data.items.map(mapLineItem).filter(Boolean);
      } else if (data && (data.variant_id || data.id || data.key)) {
        var mapped = mapLineItem(data, 0);
        if (mapped) addedItems = [mapped];
      }
      if (addedItems.length) fireAddToCart(addedItems, CURRENCY);
      getCart()
        .then(syncCartSnapshot)
        .catch(function () {});
      return;
    }

    if (isClear) {
      if (beforeCart && beforeCart.items && beforeCart.items.length) {
        fireRemoveFromCart(mapCartItems(beforeCart), CURRENCY);
      }
      syncCartSnapshot({ items: [], item_count: 0, total_price: 0, currency: CURRENCY });
      return;
    }

    if (isChange) {
      // Prefer full cart after mutation
      var afterPromise =
        data && data.items
          ? Promise.resolve(data)
          : getCart().catch(function () {
              return data;
            });
      afterPromise.then(function (afterCart) {
        var diff = diffCarts(beforeCart, afterCart);
        if (diff.added.length) fireAddToCart(diff.added, CURRENCY);
        if (diff.removed.length) fireRemoveFromCart(diff.removed, CURRENCY);
        syncCartSnapshot(afterCart);
      });
    }
  }

  // begin_checkout is owned by the Shopify custom pixel (checkout_started) only — no storefront click handler, to avoid GTM doubles.

  // Theme / app custom events
  document.addEventListener('inforce:add_to_cart', function (e) {
    var d = (e && e.detail) || {};
    if (d.items) fireAddToCart(d.items, d.currency || CURRENCY);
  });
  document.addEventListener('inforce:remove_from_cart', function (e) {
    var d = (e && e.detail) || {};
    if (d.items) fireRemoveFromCart(d.items, d.currency || CURRENCY);
  });
  document.addEventListener('inforce:begin_checkout', function () {
    fireBeginCheckout();
  });
  document.addEventListener('inforce:view_cart', function () {
    getCart().then(fireViewCart).catch(function () {});
  });

  // Shopify theme publisher-style events (best-effort)
  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail && (e.detail.cart || e.detail);
    if (cart && cart.items) syncCartSnapshot(cart);
  });
})();
